"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.analyze = exports.getLawTitleLength = void 0;
const getSentenceEnvs_1 = __importDefault(require("./getSentenceEnvs"));
const detectVariableReferences_1 = __importDefault(require("./detectVariableReferences"));
const detectDeclarations_1 = __importDefault(require("./detectDeclarations"));
const getPointerEnvs_1 = __importDefault(require("./pointerEnvs/getPointerEnvs"));
const getScope_1 = __importDefault(require("./pointerEnvs/getScope"));
const detectPointers_1 = __importDefault(require("./detectPointers"));
const getLawList_1 = require("../law/getLawList");
let _lawTitleLength = null;
const getLawTitleLength = async () => {
    if (!_lawTitleLength) {
        const lawList = await (0, getLawList_1.getLawList)();
        const lawByLawNum = Object.fromEntries(lawList.map((item) => [item.lawNum, item]));
        _lawTitleLength = (lawNum) => {
            return lawByLawNum[lawNum]?.lawTitle.length ?? null;
        };
    }
    return _lawTitleLength;
};
exports.getLawTitleLength = getLawTitleLength;
const analyze = async (options) => {
    const { elToBeModified, } = options;
    const errors = [];
    const lawTitleLength = await (0, exports.getLawTitleLength)();
    const sentenceEnvsStruct = (0, getSentenceEnvs_1.default)(elToBeModified);
    const appdxPointersResult = (0, detectPointers_1.default)(elToBeModified);
    errors.push(...appdxPointersResult.errors);
    const appdxPointers = appdxPointersResult.value;
    const getPointerEnvsResult = (0, getPointerEnvs_1.default)({ sentenceEnvsStruct, appdxPointers });
    errors.push(...getPointerEnvsResult.errors);
    const pointerEnvsStruct = getPointerEnvsResult.value;
    // detectDeclarations partially locates PointerRanges, assuming the located PointerRanges are all internal.
    const detectDeclarationsResult = (0, detectDeclarations_1.default)(sentenceEnvsStruct, pointerEnvsStruct, lawTitleLength);
    const declarations = detectDeclarationsResult.value.declarations;
    const lawRefByDeclarationID = detectDeclarationsResult.value.lawRefByDeclarationID;
    errors.push(...detectDeclarationsResult.errors);
    const detectVariableReferencesResult = (0, detectVariableReferences_1.default)(sentenceEnvsStruct, declarations, lawRefByDeclarationID, pointerEnvsStruct);
    const variableReferences = detectVariableReferencesResult.value.varRefs;
    errors.push(...detectVariableReferencesResult.errors);
    // Locate remaining PointerRanges. This time, the remaining PointerRanges are located considering LawRef's and VarRef's for laws.
    for (const pointerRanges of pointerEnvsStruct.pointerRangesList) {
        (0, getScope_1.default)({
            pointerRangesToBeModified: pointerRanges,
            pointerEnvsStruct,
            locateOptions: {
                declarations: declarations.db,
                lawRefByDeclarationID,
                force: true,
            },
        });
    }
    return {
        declarations,
        variableReferences,
        ...sentenceEnvsStruct,
        ...pointerEnvsStruct,
        errors,
    };
};
exports.analyze = analyze;
//# sourceMappingURL=index.js.map